import axios from 'axios';

import auth from "@/store/authentication.js";
const user_role = auth.state.user_role;

export default {
    findAll(ctx) {
        return axios.get(api_url + user_role + "/events", {
            params: { ctx: ctx }
        });
    },
    find(id) {
        return axios.get(api_url + user_role + "/events/" + id);
    },
    create(params) {
        return axios.post(api_url + user_role + "/events", params);
    },
    update(params) {
        return axios.put(api_url + user_role + "/events", params);
    },
    delete(id) {
        return axios.delete(api_url + user_role + "/events/", id);
    },
    fields() {
      return axios.get(api_url + user_role + "/events/fields");
    }
}



// WEBPACK FOOTER //
// ./src/api/event.js